///<amd-module name="typeahead/core/logging/FlightOriginPopulationMetric" />

/**
 * Created by matterickson on 7/27/17.
 */

export class FlightOriginPopulationMetric {
    private populatedOrigin: string;
    private submittedOrigin: string;
    private latitude: string;
    private longitude: string;
    private type: string;

    constructor(populatedOrigin: string, submittedOrigin: string, latitude: string, longitude: string) {
        this.populatedOrigin = populatedOrigin;
        this.submittedOrigin = submittedOrigin;
        this.latitude = latitude;
        this.longitude = longitude;
        this.type = "flightOriginPopulation";
    }
}
